/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import IllustratedMessage from '@react/react-spectrum/IllustratedMessage';
import { defineMessages, useIntl } from 'react-intl';

import { Maintenance } from '../Icons';

const messages = defineMessages({
    headlineMaintenance: {
        id: 'headline.maintenance',
        defaultMessage: 'Maintenance'
    },
    errorPageCurrentlyNotAvailable: {
        id: 'error.pageCurrentlyNotAvailable',
        defaultMessage: 'This page is currently not available.'
    }
});

const MaintenanceMessage = () => {
    const { formatMessage } = useIntl();

    return (
        <IllustratedMessage
            heading={formatMessage(messages.headlineMaintenance)}
            description={formatMessage(messages.errorPageCurrentlyNotAvailable)}
            illustration={<Maintenance width="150" height="150" />}
        />
    );
};

export default MaintenanceMessage;
